import { buildCartItemsForAirtable } from './buildCartItemsForAirtable.js';
import { checkoutFetch, withCheckoutDeadline } from './checkoutDeadline.js';

// Only used when retrying an existing checkout. Send byte digests rather than
// artwork bodies, and preserve the original upload order and exact dimensions.
export async function buildCheckoutRetryIntent({ cartItems, customer, amount, paymentMethod, withDelivery,
  signal, timeoutMs = 10000, fetcher = checkoutFetch, digest = (bytes) => crypto.subtle.digest('SHA-256', bytes) }) {
  return withCheckoutDeadline(async (signal) => {
    const artwork = [];
    for (const [itemIndex, item] of cartItems.entries()) {
      const areas = new Map((item.selectedPrintAreas || []).map((area) =>
        typeof area === 'string' ? [area, 'print'] : [area.areaKey, area.method || 'print']));
      for (const [areaKey, design] of Object.entries(item.uploadedDesigns || {})) {
        if (!areas.has(areaKey) || !design?.url) continue;
        const response = await fetcher(design.originalUrl || design.url, { signal });
        if (!response.ok) throw new Error('checkout_artwork_unavailable');
        const hash = await digest(await response.arrayBuffer());
        if (signal.aborted) throw signal.reason;
        artwork.push({ itemIndex, areaKey, method: areas.get(areaKey), name: design.name || `${areaKey}.png`,
          sha256: [...new Uint8Array(hash)].map((byte) => byte.toString(16).padStart(2, '0')).join('') });
      }
    }
    return { amount_agorot: Math.round(amount * 100), currency: 'ILS', payment_method: paymentMethod,
      customer, with_delivery: withDelivery, cart_items: buildCartItemsForAirtable(cartItems), artwork };
  }, { timeoutMs, signal });
}
